import React from 'react' 
import { TableCheckBox } from './DataTypeRow'
import { Button } from '@blueprintjs/core'
import { getTableRows } from './utils'
import { __ } from '../../../../libs/utilities'
import { Link } from 'react-router-dom'
import { IAdminStore,  useAdminStore } from '../../data/store'
import { IBulk } from '../../data/interfaces'

const DataTableLayout = (props:any) => {
    const bulks: IBulk[]    = useAdminStore((state:IAdminStore) => state.bulks) 
    const setBulks: ((bulks: IBulk[]) => void)  = useAdminStore((state:IAdminStore) => state.setBulks) 
    const items: any[]      = useAdminStore((state:IAdminStore) => state.items) 
    const data_type: string = useAdminStore((state:IAdminStore) => state.data_type) 
    
    const fields = { ...props.params.fields }
    const threads : any[] = getTableRows( fields )
    const colors = !!props.params.fields.admin_data.fill.length ? props.params.fields.admin_data.fill : ["#293742" , "#252c32"]
    const onMainBulk = (checked: boolean) => {
        const _bulks = items.map( (item : any) => 
        {
            return {
                id: item.id,
                data_type,
                checked
            } 
        })  
        console.log(items, _bulks, data_type)
        setBulks( _bulks )
    }
    // console.log( props )
    return <table className={ `table table-striped table-hover ${props.containerClassName} ` } role="table" data-testid="data-table-layout"> 
        <thead  
            style={{ 
                backgroundColor : colors[0],
                background: `linear-gradient(to right,  ${colors[0]} 0%,${colors[1]} 100%)`,
                color : "#EEE"
            }}
            data-testid="data-table-thread"
        >
            <tr role="row">
                <th style={{ width: 50 }} role="cell" data-testid="data-table-thread-checkbox">
                    <TableCheckBox 
                        {...props} 
                        checked={ !bulks.filter((bulk: IBulk) => !bulk.checked).length }
                        onChecked={ onMainBulk } 
                    /> {/* */}
                </th>
                {
                    threads.map(thread => {
                        const af = fields.apollo_fields[thread]
                        const style: any ={
                            width: af.col_width,
                            minWidth: af.col_width
                        }
                        return <th key={thread} data-thread={thread} style={style} data-testid={`data-table-thread-${thread}`}>
                            <div className="flex-centered">
                            { 
                                af.col_icon 
                                    ? 
                                    <div className="hint hint--top" data-hint={__(af.title)} >
                                        <i className={ `${af.col_icon} ` }/> 
                                    </div>
                                    : 
                                    __(af.title) 
                            }  
                            </div> 
                        </th>
                    })
                }
                <th  style={{ width: 200 }} role="cell" data-testid="data-table-thread-edit">
                    <Link className='' to={`new`}>
                        <Button 
                           variant="minimal" 

                        >
                            <div className="hint hint--top " data-hint={__("Add new")}>
                                <i className="fas fa-plus text-light" /> 
                            </div>                        
                        </Button> 
                    </Link> 
                    {/*
                        <Button 
                            variant="minimal" 
                        >
                            <div className="hint hint--top" data-hint={__("Package add")}>
                                <i className="fas fa-th  text-light" />
                            </div>                        
                        </Button>
                    */}                 
                     
                </th>
            </tr>
        </thead>
        <tbody>
            { props.children }
        </tbody>
    </table> 
}

export default DataTableLayout